import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { H1 } from '@osmosis/tailwind-ui/components/Text';
import { H2 } from '@osmosis/tailwind-ui/components/Text';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import Image from 'next/image';
import headingSchema from '../../../lib/composer/schemas/heading';
import subheadingSchema from '../../../lib/composer/schemas/subheading';
import themeSchema from '../../../lib/composer/schemas/theme';
import {
  AnswersSchemaProps,
  answersSchema,
  citationsSchema,
} from '../../../lib/composer/schemas/answers';
import { FormattedMessage } from 'react-intl';

type Props = {
  heading: string;
  subheading: string;
  image: string;
  citations: { name: string; type: string }[];
  answers: AnswersSchemaProps[];
  alignment: string;
  width: string;
  theme: string;
  modified: string;
};

const mapQA = ({ question, answer }: { question: string; answer: string }) => (
  <Flex cn="flex-col" key={question}>
    <H3 cn="my-3">{question}</H3>
    <P dangerouslySetInnerHTML={{ __html: answer }}></P>
  </Flex>
);

/**
 * Answers block for answer pages
 * @returns
 */
const Answers = (props: Props) => {
  const { heading, subheading, image, citations, answers, modified } = props;
  const [firstQuestion] = answers;
  return (
    <Flex cn="flex-col items-center max-w-[860px] my-3">
      <H1 cn="my-3">{heading}</H1>
      <H2 cn="my-3">{subheading}</H2>
      <Flex cn="flex-col items-center my-3">
        {citations.map((citation, index) => (
          <P cn="italic text-slate-500" key={index}>
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            {citation.type}: {citation.name}
          </P>
        ))}
        {modified && (
          <P cn="italic text-slate-500">
            <FormattedMessage
              id="answers.modified"
              defaultMessage="Modified: "
            />

            {modified}
          </P>
        )}
      </Flex>
      {[firstQuestion].map(mapQA)}
      <Image src={image} alt={heading} priority width={1200} height={972} />
      {answers.slice(1).map(mapQA)}
    </Flex>
  );
};

export default Answers;

Answers.schema = {
  name: 'answers',
  label: 'Answers',
  editableProps: [
    headingSchema,
    subheadingSchema,
    citationsSchema,
    answersSchema,
    themeSchema,
  ],
};
